(function () {
  'use strict';

  d3.chart('ChartBase').extend('Legend', {
    initialize : function (options) {
      var plot = this,
          bases;
      options = options || {};

      plot.color = options.color;
      if (!plot.color) {
        throw new Error('Legend requires a color option which is the ordinal scale for series color');
      }

      bases = {
        legend : plot.wrap.append('g').classed('legend', true)
      };

      plot.layer('series', bases.legend, {
        dataBind : function (data) {
          return this.selectAll('.legend-series')
              .data(data.series);
        },
        insert : function () {
          var group = this.append('g')
              .classed('legend-series', true);

          group.append('rect')
              .classed('legend-box', true)
              .attr('width', 10)
              .attr('height', 10);

          group.append('text')
              .classed('legend-text', true)
              .translate(20, 10);

          return group;
        },
        events : {
          merge : function () {
            this.select('rect')
                .style({
                  fill : function (d) { return plot.color(d.name); },
                  stroke : '#000',
                  'shape-rendering' : 'crispEdges'
                });

            this.select('text')
                .text(_.property('name'));

            // todo: this could be abstracted into a utility
            var lefts = [0]; // the first one starts at 0
            var SPACING = 20;
            this.each(function () {
              var left = lefts[lefts.length - 1];
              var next = left + this.getBBox().width + SPACING;
              lefts.push(next);

              d3.select(this).translate(left, 0);
            });
          }
        }
      });
    }
  });

})();
